
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="Ghs07Svg" xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 3000 3000"><path d="M749.5 750l-750 750 750.3 750.3 750.2 750.2 750.2-750.2 750.2-750.3-749.9-750C1838 337.5 1500.3 0 1500 0c-.3 0-338 337.5-750.5 750zM2131 869.5l630.5 630.5-630.8 630.8-630.7 630.7-630.7-630.7L238.5 1500 869 869.5C1215.8 522.7 1499.7 239 1500 239c.3 0 284.2 283.7 631 630.5z"/><path d="M1477.3 724.6c-47.9 5.2-87.9 18.7-121.5 41.1-36.2 24.1-57.9 55.7-61.9 90.5-1.4 12-1.9 7.6 8 73.3 7.1 47.8 16.8 112.8 22.1 149 1.6 11 8.6 58 15.5 104.5s13.9 93.7 15.6 105c3.6 24.7 16.9 114.5 24.4 165 6 40.4 18.8 128 20.6 140.5 3.2 23.4 14.4 45.3 32.3 63.1 10.6 10.5 18.3 16 31 22 14.3 6.7 25.6 9.5 42.1 10.1 21.9.9 37.3-2.4 55.9-12 32.9-16.8 54.8-48.2 60.1-86.2.9-6.1 3.8-26.1 6.5-44.5 13.5-91.6 22.6-153.2 28-189.5 3.3-22 9.8-65.9 14.4-97.5 38.7-261.7 50-338.2 52.7-355.5 1.7-11 3.5-23.2 4.1-27 2.3-16-1.6-37.6-10.1-54.8-23.1-46.8-81.5-82.6-154.5-94.6-25.7-4.3-60.2-5.3-85.3-2.5zM1491 1788c-56.3 7.8-103.4 42.6-129 95.5-13.3 27.4-18.8 54.6-17.7 87 2.9 84.6 62.6 154.5 142.5 167.1 14.6 2.3 43.6 1.5 56.7-1.5 20.5-4.8 38.9-12.6 55.4-23.6 38.6-25.7 64.7-64.9 74.8-112.4 2.5-11.6 2.7-14.5 2.8-36.6 0-21.5-.2-25.2-2.4-35.5-14.8-71.3-65.2-123.8-132.6-138-11.4-2.4-39.5-3.5-50.5-2z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'Ghs07Svg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
